import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Attachment } from './attachments.component';
import { AttachmentMetadata } from './base-attachments';

@Injectable({
  providedIn: 'root'
})
export class BaseAttachmentsService {
  public metadataKeyToAttachmentsMap: { [key: string]: Attachment[] } = {};
  public centralFormControl: FormControl;
  private isCentralizedControl = false;

  constructor() {}

  public linkAllAttachmentsToCentralizedControl(centralFormControl: FormControl) {
    this.centralFormControl = centralFormControl;
    this.isCentralizedControl = true;
    this.initializeMetadataKeyToAttachmentsMap();
  }

  public onAttachmentsUpdated(metadata: AttachmentMetadata, files: File[] | Attachment[]) {
    if (!this.isCentralizedControl) {
      return;
    }
    this.updateMetadataKeyToAttachmentsMap(metadata.key, files);
    this.syncCentralFormControlWithMetadataKeyToAttachmentsMap();
  }

  public updateMetadataKeyToAttachmentsMap(metadataKey: string, files: File[] | Attachment[]) {
    if (!files) return;
    this.metadataKeyToAttachmentsMap[metadataKey] = [...files];
  }

  // Initializes metadataKeyToAttachmentsMap based on values in the central form control
  public initializeMetadataKeyToAttachmentsMap() {
    if (!this.centralFormControl) return;
    this.metadataKeyToAttachmentsMap = {};
    for (const attachment of this.centralFormControl.value) {
      if (attachment['metadata']) {
        const metadataKey = JSON.parse(attachment['metadata']).key;
        this.metadataKeyToAttachmentsMap[metadataKey] = [
          ...(this.metadataKeyToAttachmentsMap[metadataKey] || []),
          attachment
        ];
      }
    }
  }

  checkMetadata(key: string, value: string, compareTo: { [key: string]: string }) {
    if (compareTo && compareTo[key] && compareTo[key] === value) {
      return true;
    }
    return false;
  }

  // Updates the central form control based on values in the metadataKeyToAttachmentsMap
  public syncCentralFormControlWithMetadataKeyToAttachmentsMap() {
    if (!this.centralFormControl) {
      return;
    }
    let localAttachments = [];
    for (const attachment of this.centralFormControl.value) {
      if (!attachment['metadata']) {
        localAttachments.push(attachment);
      }
    }
    let incomingAttachments = [];
    Object.values(this.metadataKeyToAttachmentsMap).forEach(attachments => {
      incomingAttachments = [...incomingAttachments, ...attachments];
    });

    localAttachments = [...localAttachments, ...incomingAttachments];
    if (this.centralFormControl) {
      this.centralFormControl.setValue(localAttachments);
    }
  }

  generateMetadata(key: string): AttachmentMetadata {
    return { ['key']: key, uploadDate: '' + new Date().getTime() };
  }
}
